import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import {
  toggleHistory
} from "../../actions/domActions";

import {
  addNotification,
  dismissNotification,
} from "../../actions/userActions";

export function Notice({ addNotification, daysAllowed, daysSinceEntry, dismissNotification, hasMostRecent, viewHistory }) {
  useEffect(function() {
    if (daysSinceEntry >= daysAllowed || !hasMostRecent) {
      const message = hasMostRecent
        ? `It has been ${daysSinceEntry} ${daysSinceEntry > 1 ? "days" : "day"} since you last submitted a time entry`
        : "You haven't submitted any time entries yet";

      addNotification(
        <span>
          {message}.&nbsp;
          <a onClick={viewHistory}>View Entries</a>
        </span>
      );
    }

    return dismissNotification;
  }, [addNotification, daysAllowed, daysSinceEntry, hasMostRecent, viewHistory]);

  return null;
}

Notice.displayName = "TimeInput.Notice";

Notice.propTypes = {
  addNotification: PropTypes.func.isRequired,
  daysAllowed: PropTypes.number.isRequired,
  daysSinceEntry: PropTypes.number.isRequired,
  dismissNotification: PropTypes.func.isRequired,
  hasMostRecent: PropTypes.bool.isRequired,
  viewHistory: PropTypes.func.isRequired,
};

function mapStateToProps(state, ownProps) {
  return {
    daysAllowed: get(state, "userRole.notificationDelay", 7),
    daysSinceEntry: get(state, "entries.daysSinceEntry", 0),
    hasMostRecent: Boolean(get(state, "entries.mostRecent")),
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    addNotification: (notification) => dispatch(addNotification(notification)),
    dismissNotification: () => dispatch(dismissNotification()),
    viewHistory: () => dispatch(toggleHistory(false)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Notice);



// WEBPACK FOOTER //
// ./app/components/TimeInput/Notice.jsx